import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgPipesModule } from 'ngx-pipes';
import {
  DxButtonModule,
  DxDataGridModule,
  DxDateBoxModule,
  DxLookupModule,
  DxPopupModule,
  DxScrollViewModule,
  DxTemplateModule,
  DxTextAreaModule,
} from 'devextreme-angular';
import { GSModule } from 'src/app/libs/gs.module';
import { AttendanceEntriesAddComponent } from '../attendance-entries-add/attendance-entries-add.component';
import { HrAttendanceEntriesEditPopupComponent } from '../hr-attendance-entries-edit-popup/hr-attendance-entries-edit-popup.component';
import { ClockingInTerminalComponent } from './clocking-in-terminal.component';

@NgModule({
  declarations: [
    ClockingInTerminalComponent,
    HrAttendanceEntriesEditPopupComponent,
    AttendanceEntriesAddComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    NgPipesModule,
    GSModule,
    DxButtonModule,
    DxDataGridModule,
    DxDateBoxModule,
    DxLookupModule,
    DxPopupModule,
    DxScrollViewModule,
    DxTemplateModule,
    DxTextAreaModule,
  ],
  exports: [AttendanceEntriesAddComponent],
})
export class ClockingInTerminalModule { }
